<template>
  <div id="app">
    <i class="material-icons md-96">block</i>

    <h1>Woops, this page does not exist</h1>

    <a href="/" class="button">Go to home</a>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>
